export class Certification {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.certificationId = ''
    this.certificationName = ''
    this.authorityName = ''
    this.awardedDate = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/Certification.js